import React, { useEffect, useState } from 'react';
import { Sun, Luggage, MapPin } from 'lucide-react';
import '../../css/general.css';
import Layout from '../Layout';
import Hero from '../Hero';
import carSeat from '../../img/child-safety-seat-back-car.jpg';
import babyCrib from '../../img/high-angle-woman-playing-with-baby.jpg';
import babyStroller from '../../img/young-mother-walking-with-baby-carriage-park.jpg';
import { getData } from '../../helpers/ApiSettings';
import { Link } from 'react-router-dom';

const IndexPage = () => {
  const [homeData, setHomeData] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getData('/home?populate=*');
      setHomeData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  if (!homeData) {
    return null;
  }

  return (
    <Layout>
      <Hero homeData={homeData.data} />
      <div className='container main'>
        <section className='services'>
          <div className="row">
            {[
              { icon: Sun, color: 'text-warning', title: 'Voyagez léger', description: 'Plus besoin de transporter tout l\'équipement de bébé. Nous nous occupons de tout !' },
              { icon: Luggage, color: 'text-primary', title: 'Gamme complète', description: 'De la poussette au chauffe-biberon, nous avons tout ce dont bébé a besoin.' },
              { icon: MapPin, color: 'text-danger', title: 'Livraison partout', description: 'Livraison sur votre lieu de séjour ou en point relais dans toute la Guadeloupe.' }
            ].map((item, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="card h-100 text-center p-4 ovlm-card">
                  <item.icon className={`mx-auto mb-3 ${item.color}`} size={64} />
                  <h3 className="h4 mb-3">{item.title}</h3>
                  <p className="text-muted">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {homeData.data.sections.map((item, index) => (
          <section key={index} className="about">
            <div className="container text-center">
              <h2 className="section-title ovlm-gradient-text">{item.title}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: item.contenu }}
              />
              {item.button && (
                <a href={item.url} className="btn btn-primary btn-lg mt-3">En savoir plus</a>
              )}
            </div>
          </section>
        ))}

        <section className="services">
          <div className="container text-center">
            <h2 className="section-title ovlm-gradient-text">Nos Services</h2>
            <div className="row">
              <div className="col-md-4 service-item">
                <div className="card">
                  <div className="card-body">
                    <img src={babyStroller} alt="poussette bébé" />
                    <div className='card-content'>
                      <h5 className="card-title">Louez des poussettes</h5>
                      <p className="card-text">Nous proposons des poussettes de haute qualité à la location, rendant vos voyages légers et confortables.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 service-item">
                <div className="card">
                  <div className="card-body">
                    <img src={carSeat} alt="siège auto" />
                    <div className='card-content'>
                      <h5 className="card-title">Louez des sièges auto</h5>
                      <p className="card-text">Nos sièges auto sont sûrs et confortables pour vos petits, et sont disponibles à la location.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 service-item">
                <div className="card">
                  <div className="card-body">
                    <img src={babyCrib} alt="lit bébé" />
                    <div className='card-content'>
                      <h5 className="card-title">Louez des lits bébé</h5>
                      <p className="card-text">Louez des lits bébé qui offrent un confort comme à la maison pour votre enfant pendant vos voyages.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Link to="/services/location" className="btn btn-primary btn-lg mt-3">Commencer aujourd'hui</Link>
          </div>
        </section>

        {/* <section className="testimonials">
          <div className="container text-center">
            <h2 className="section-title ovlm-gradient-text">Testimonials</h2>
            <div className="row">
              <div className="col-md-4 testimonial-item">
                <div className="card">
                  <div className="card-body">
                    <img src="https://via.placeholder.com/100" width="100" alt="Client 1" />
                    <h5 className="card-title">Jane Doe</h5>
                    <p className="card-text">"OVLM made our family vacation so much easier! The rented stroller was a lifesaver."</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 testimonial-item">
                <div className="card">
                  <div className="card-body">
                    <img src="https://via.placeholder.com/100" width="100" alt="Client 2" />
                    <h5 className="card-title">John Smith</h5>
                    <p className="card-text">"Excellent service and high-quality products. I highly recommend OVLM for stress-free travels."</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 testimonial-item">
                <div className="card">
                  <div className="card-body">
                    <img src="https://via.placeholder.com/100" width="100" alt="Client 3" />
                    <h5 className="card-title">Mary Johnson</h5>
                    <p className="card-text">"From booking to delivery, everything was seamless. My kids loved the rented toys!"</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

      </div>
    </Layout>
  );
};

export default IndexPage;